/**
 * EL INTRA Y EL POST QUE EL CLIENTE QUITA NO VUELVEN SOLOS (Francisco, 16-10).
 *
 * Al abrir un día de entreno sin nada, Nutrición le pone el intra y el post de su último
 * día de entreno (`/diets/ultimo-peri`). Si el cliente los quitaba, al volver a entrar en
 * el día se ponían otra vez.
 *
 * El relleno solo ocurre en un día SIN NINGÚN alimento, y un día así no está creado (el
 * peri puesto solo no lo crea, 14-10). Por eso la marca no va en el día del servidor:
 * guardarla allí creaba un documento vacío que la ficha, la renovación y «copiar semana»
 * contaban como día de verdad. Va en el navegador, por cliente (`almacenLocal`), y se borra
 * al cerrar sesión como el resto de lo suyo. En otro aparato el peri se vuelve a proponer,
 * pero no se guarda mientras el día no tenga nada más.
 */
import { leer, escribir, borrar } from './almacenLocal';

const PERI = ['Intra', 'Post'];
const nombre = (fecha) => `peri_quitado_${fecha}`;

/** Las comidas del peri que el cliente quitó en esa fecha (`['Intra']`, `['Intra', 'Post']`...). */
export const periQuitadoDe = (fecha, userId) => {
    try {
        const lista = JSON.parse(leer(nombre(fecha), userId) || '[]');
        return Array.isArray(lista) ? lista.filter((k) => PERI.includes(k)) : [];
    } catch { return []; }
};

/** Apunta que el cliente dejó vacía esa comida del peri. Las demás comidas no se apuntan. */
export const apuntarPeriQuitado = (fecha, userId, comida) => {
    if (!fecha || !PERI.includes(comida)) return;
    const ya = periQuitadoDe(fecha, userId);
    if (ya.includes(comida)) return;
    escribir(nombre(fecha), userId, JSON.stringify([...ya, comida]));
};

/** Lo contrario: el cliente volvió a montar esas comidas del peri. Lo que se puso solo no
 *  cuenta (no llega aquí: `loQueSeGuarda` lo deja fuera). */
export const olvidarPeriQuitado = (fecha, userId, comidas) => {
    const ya = periQuitadoDe(fecha, userId);
    const quedan = ya.filter((k) => !comidas.includes(k));
    if (quedan.length === ya.length) return;
    if (quedan.length) escribir(nombre(fecha), userId, JSON.stringify(quedan));
    else borrar(nombre(fecha), userId);
};
